package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.SpaceDimension
import com.wintermar.inspection.core.ui.util.SelectionModel
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateQuestionModel
import com.wintermar.inspection.feature.presentation.inspection.answer.widget.choice_answer.ChoiceAnswer
import com.wintermar.inspection.feature.presentation.inspection.answer.widget.content_item_button.ContentItemButton
import com.wintermar.inspection.graphql.type.FindingCategory

data class ContentItemProps(
    val item: InspectionTemplateQuestionModel,
    val vesselList: List<SelectionModel>,
    val showActionButton: Boolean,
    val isInternalAudit: Boolean,
    val onChooseAnswer: (answerId: String) -> Unit,
    val onClickVessel: (id: String, value: String) -> Unit,
    val onSetAnswerTextChanged: (value: String) -> Unit,
    val onDeleteNotes: () -> Unit,
    val onDeleteFiles: () -> Unit,
    val onShowModalGuidance: () -> Unit,
    val onShowModalCalendar: () -> Unit,
    val onShowModalLocation: () -> Unit,
    val onShowModalNotes: () -> Unit,
    val onShowModalFiles: () -> Unit,
    val onShowFindingCategory: (FindingCategory?) -> Unit
)

@Composable
fun ContentItem(
    props: ContentItemProps,
    keyword: String = "",
    topPadding: Dp = LocalAppTheme.current.dimension.spacing.space5,
    showLinkQuestion: Boolean = false,
    onGoToQuestion: () -> Unit = {}
) {
    val dimension: AppDimension = LocalAppTheme.current.dimension
    Column(
        modifier = Modifier.fillMaxWidth().padding(
            top = topPadding,
            bottom = dimension.spacing.space5,
            start = dimension.spacing.space4,
            end = dimension.spacing.space4
        ),
        verticalArrangement = Arrangement.spacedBy(dimension.spacing.space5)
    ) {
        ContentItemQuestion(
            item = props.item,
            keyword = keyword,
            showLinkQuestion = showLinkQuestion,
            onShowModalGuidance = {
                props.onShowModalGuidance()
            },
            onGoToQuestion = {
                onGoToQuestion()
            }
        )
        InputQuestion(
            question = props.item,
            vessels = props.vesselList,
            onClick = { answerId ->
                props.onChooseAnswer(answerId)
            },
            onShowCalendarModal = {
                props.onShowModalCalendar()
            },
            onShowLocationModal = {
                props.onShowModalLocation()
            },
            onClickVessel = { vessel ->
                props.onClickVessel(vessel.id, vessel.value)
            },
            onValueChanged = { answerText ->
                props.onSetAnswerTextChanged(answerText)
            }
        )

        if (props.showActionButton) {
            ContentItemNotes(
                notes = props.item.answer.notes,
                onEditNotes = {
                    props.onShowModalNotes()
                },
                onDeleteNotes = {
                    props.onDeleteNotes()
                }
            )

            ContentItemFile(
                files = props.item.answer.files,
                onEditFiles = {
                    props.onShowModalFiles()
                },
                onDeleteFiles = {
                    props.onDeleteFiles()
                }
            )

            ContentItemButton(
                answer = props.item.answer,
                answerType = props.item.answerType,
                onShowModalNotes = {
                    props.onShowModalNotes()
                },
                onShowModalFiles = {
                    props.onShowModalFiles()
                },
                onShowFindingCategory = {
                    props.onShowFindingCategory(null)
                }
            )

            ContentItemFindingCategory(
                show = props.item.answer.isRequiredFileOrNotes && !props.item.answer.isEmptyFindingCategory(),
                findingCategory = props.item.answer.findingCategory ?: FindingCategory.UNKNOWN__,
                disableClick = !props.isInternalAudit,
                onClick = {
                    props.onShowFindingCategory(props.item.answer.findingCategory)
                }
            )
        }
    }
}
